"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

/**
 * Legacy Storyblok signup component — redirects to the new /login page.
 * Kept registered so existing Storyblok pages using it don't break.
 */
const Signup = () => {
  const router = useRouter();

  useEffect(() => {
    router.replace("/login");
  }, [router]);

  return null;
};

export default Signup;
